import { Flex, Text } from "../../../../components";
import React, { useState } from "react";
import styled from "styled-components";

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg};
`;

const Container = styled(Flex)`
  width: 100%;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
  background: #161930;
  border-radius: 5px;
  padding: 12px 18px;
  margin-bottom: 12px;
`;

const TruncateText = styled(Text.Body)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusText = styled(TruncateText)`
  --red: #FF5071;
  --orange: #FFB25C;
  --green: #60FFB0;
  color: var(--${props => props.color || 'green'});
`;

const Type = ({ revealEditModal, data }) => {
  const [typeData, setTypeData] = useState(data);
  const [showModal, setModal] = useState(false);

  return (
    <Container align='center' minw="840px">
      <Flex w="5%">
        <TruncateText>{typeData.name}</TruncateText>
      </Flex>
      <Flex w="5%">
        <TruncateText>{typeData.label}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.discord_role_id}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.one_time_fee ? typeData.one_time_fee : 'N/A'}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.recurring_fee ? typeData.recurring_fee : 'N/A'}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.trial_amount}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.unbindable ? "Yes" : "No"}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.unbind_delay}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{typeData.max_instances}</TruncateText>
      </Flex>
      <Flex w="5%">
        <TruncateText>{typeData.renewal_length ? typeData.renewal_length : 'N/A'}</TruncateText>
      </Flex>
      <Flex fg="1" />
      <Button bg="#0393FF"
        onClick={ () => revealEditModal(typeData)}
      >Edit</Button>
    </Container>
  )
}

export default Type;
